import React from "react";
import { Button } from "./ui/button.jsx";
import { AnimatedSection } from "./IntersectionObserver.tsx";

const Hero: React.FC = () => {
  const scrollToContact = (): void => {
    const element = document.getElementById("contact");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToCases = (): void => {
    const element = document.getElementById("case-studies");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="top" className="hero-section">
      <div className="hero-gradient"></div>
      <div className="dark-container">
        <div className="hero-content">
          <div className="hero-left">
            <AnimatedSection>
              <h1 className="display-huge">
                Премиальный <br />
                e-commerce <br />
                для модных брендов
              </h1>
            </AnimatedSection>

            <AnimatedSection delay={1}>
              <p className="body-large hero-subhead">
                Индивидуальный дизайн, безупречная производительность, рост конверсии на основе реальных метрик.
              </p>
            </AnimatedSection>

            <AnimatedSection delay={3}>
              <div className="hero-cta">
                <Button
                  className="btn-primary hero-btn"
                  onClick={scrollToContact}
                >
                  Обсудить проект
                </Button>
              </div>
            </AnimatedSection>
          </div>

          <AnimatedSection delay={1}>
            <div className="hero-right">
              <div className="hero-mockup">
                <div className="mockup-card">
                  <div className="mockup-image"></div>
                  <div className="mockup-content">
                    <div className="mockup-title"></div>
                    <div className="mockup-subtitle"></div>
                    <div className="mockup-price"></div>
                  </div>
                </div>
                <div className="mockup-card mockup-card-offset">
                  <div className="mockup-image mockup-image-2"></div>
                  <div className="mockup-content">
                    <div className="mockup-title"></div>
                    <div className="mockup-subtitle"></div>
                    <div className="mockup-price"></div>
                  </div>
                </div>
              </div>
              <div className="hero-shapes">
                <div className="shape-1"></div>
                <div className="shape-2"></div>
              </div>
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
};

export default Hero;